export default __webpack_public_path__ + "static/media/Eggstraterrestrial.e381717f.png";